module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Rim-58c61c7a186495e2b4aefa5e780eed28.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Rim.mp3
// module id = 56
// module chunks = 0